<section>
  <section 
    class="drawer-modal p-4" 
    [ngClass]="{'drawer-modal--open': isDrawerOpen}" 
    [ngStyle]="{ 'border-radius': isFullScreen ? '0px' : '12px 12px 0px 0px', 'min-height': isFullScreen ? '100%': '25px'}"
    >
    <ng-content></ng-content>
  </section>
  <div [ngClass]="{'drawer-overlay': isDrawerOpen}" (click)="onOutsideClick.emit(); forceResetOverflow()"></div>
</section>